import { Container } from "inversify";
import { AuthApi, IAuthApi } from "@/api/auth";
import { IChannelApi, ChannelApi } from "@/api/channel";
import { IWebSocketApi, WebSocketApi } from "@/api/websocket";
import { IOrganizationApi, OrganizationApi } from "@/api/organization";
import { ILogsApi, LogsApi } from "@/api/logs";
import { IFeedbackApi, FeedbackApi } from "@/api/feedback";
import { ISystemMessagesApi, SystemMessagesApi } from "@/api/system-messages";
import { IOrgKpisApi, OrgKpisApi } from "@/api/org-kpis";
import { IPricingApi, PricingApi } from "@/api/pricing";
import { IPackagesApi, PackagesApi } from "@/api/packages";
import { ISubscriptionApi, SubscriptionApi } from "@/api/subscription";
import { IConfigService, ConfigService, AppConfig } from "@/services/config";
import { IStorageService, SessionStorageService } from "@/services/storage";
import { HttpClient, HttpClientFactory } from "@/services/client";
import { AppStore, store } from "@/store/root";

import { SERVICES_TYPES } from "./SERVICES_TYPES";

const container = new Container();

// Config
const configService: IConfigService = new ConfigService();
const configs = configService.bind();
container.bind<AppConfig>(SERVICES_TYPES.CONFIGURATIONS).toConstantValue(configs);

// Http Client
const httpFactory = new HttpClientFactory(configs);
const httpClient = httpFactory.create();
container.bind<HttpClient>(SERVICES_TYPES.HTTP_CLIENT).toConstantValue(httpClient);

// Storage
container.bind<IStorageService>(SERVICES_TYPES.STORAGE).to(SessionStorageService);

// Store
container.bind<AppStore>(SERVICES_TYPES.STORE).toConstantValue(store);

// Auth
container.bind<IAuthApi>(SERVICES_TYPES.AUTH).to(AuthApi);

// Channels
container.bind<IChannelApi>(SERVICES_TYPES.CHANNELS).to(ChannelApi);

// WebSocket
container.bind<IWebSocketApi>(SERVICES_TYPES.WEBSOCKET).to(WebSocketApi).inSingletonScope();

// Organization
container.bind<IOrganizationApi>(SERVICES_TYPES.ORGANIZATION).to(OrganizationApi);

// Logs
container.bind<ILogsApi>(SERVICES_TYPES.LOGS).to(LogsApi);

// Feedback
container.bind<IFeedbackApi>(SERVICES_TYPES.FEEDBACK).to(FeedbackApi);

// System Messages
container.bind<ISystemMessagesApi>(SERVICES_TYPES.SYSTEM_MESSAGES).to(SystemMessagesApi);

// Organization KPIs
container.bind<IOrgKpisApi>(SERVICES_TYPES.ORG_KPIS).to(OrgKpisApi);

// Meta pricing (rate card)
container.bind<IPricingApi>(SERVICES_TYPES.PRICING).to(PricingApi);

// Packages and each organization's plan
container.bind<IPackagesApi>(SERVICES_TYPES.PACKAGES).to(PackagesApi);

// Subscription
const subscriptionClient = httpFactory.createSubscriptionClient();
container
  .bind<HttpClient>(SERVICES_TYPES.SUBSCRIPTION_HTTP_CLIENT)
  .toConstantValue(subscriptionClient);
container.bind<ISubscriptionApi>(SERVICES_TYPES.SUBSCRIPTION_API).to(SubscriptionApi);

export { container };
